import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'
import { IBoardMember } from 'shared/models/Board'
import { getUser } from '../user/selectors'

export const getBoard = (state: RootState) => state.board

export const getBoardMembers = (state: RootState) => state.board.data?.members

export const getBoardFunctionForActiveUser = createSelector(
  [getUser, getBoard],
  (user, board) => {
    const nameId = user.data?.id

    const role = board.data?.members?.find(
      (x: IBoardMember) => x.person.id === nameId
    )
    return role?.memberFunction || ''
  }
)

export const getBoardSizeBasedOnMemberFunction = (state: RootState) => {
  const membersWithQueriedFunctions = state.board.data?.members?.filter(
    (member) => member.boardMember || member.chairman || member.deputy
  )

  return membersWithQueriedFunctions?.length || 0
}
